/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import {
  cancelAnalysis,
  getDataAnlysis,
  getDataAnlysisFull,
  getChartDetail,
  saveChart,
} from '@dbl/services/chart';
const service = {
  saveChart,
  getChartDetail,
  getDataAnlysis,
  getDataAnlysisFull,
  cancelAnalysis,
};

import moment from 'moment';
import { v4 as uid } from 'uuid';
import { DimensionType } from './components/Dimensions/Options/dimension_select';
import * as crypto from 'crypto-js';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { dtStatDate, FilterBasic, FilterOperationMap } from './components/configuration';
import {
  Analysis,
  AnalysisFilters,
  AnalysisPackageInfo,
  Condition,
  FiltersItem,
  GroupBy,
  MetricsItem,
  OrderByItem,
} from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import { ITableJoinRelation } from '../../Multidimensional/Analysis/components/HeaderData/interface';
import {getTableData, initFieldService, requestChatResult} from './service';
import { getSelector } from '@dbl/services/global';
import { getNumberPackageList } from '@dbl/services/numberPackage';
import { defaultMenu } from './components/widgets/FieldSelect';
import { generateAllMenu, tryAddNotExist } from './utils';
import { FilterMethod } from '@dbl/core/filter';
import {
  createFiltersItem,
  createGroupBy,
  createMetricsItem,
  getRequestUniqueId,
} from '../../../components/SortableDrag/baseModel';
import { checkNullString } from '../../../utils/utils';
import { aggregateObj, FuncNameMap } from '../../Multidimensional/Analysis/components/AnalysisLineChart/constants';

export const namespace = 'Action/ExploreAnalysis';

export const ColumnFilters = [
  // {
  //   column_name: '_activeUser',
  //   column_display: '活跃用户',
  //   column_type: 'BIGINT',
  //   filter_method: FilterMethod.Time,
  //   metric_method: 2,
  // },
  // {
  //   column_name: 'regCountry',
  //   column_display: '注册国家',
  //   column_type: 'BIGINT',
  //   filter_method: FilterMethod.County,
  //   column_value: ['dz', 'ao', 'bj', 'bw', 'bf', 'cv'],
  // },
  // {
  //   column_name: 'regDate',
  //   column_display: '注册时间',
  //   column_type: 'STRING',
  //   filter_method: FilterMethod.Time,
  // },
  // {
  //   column_name: 'regChannlid',
  //   column_display: '注册渠道',
  //   column_type: 'BIGINT',
  //   filter_method: FilterMethod.String,
  // },
  // {
  //   column_name: 'loginTimes',
  //   column_display: '登陆次数',
  //   column_type: 'BIGINT',
  //   filter_method: FilterMethod.Number,
  // },
] as IColumnInfo[];

export const DefaultColumnMetrics = [
  {
    column_name: '_activeUserNum',
    column_display: '活跃用户数',
    column_display_en: 'activeUserNum',
    column_type: 'BIGINT',
    metric_method: 1,
  },
] as IColumnInfo[];

const initState = () => ({
  gameCode: '',
  allFilters: [] as IColumnInfo[],
  allMetrics: [] as IColumnInfo[],
  allDimensions: [] as IColumnInfo[],
  optionFilters: [],
  optionMetrics: [],
  optionDimensions: [],
  columnFilters: [...ColumnFilters] as IColumnInfo[],
  filterLogic: 0,
  filterBasic: FilterBasic.map((it: any) => ({ ...it })),
  columnSensitive: [],
  columnMetrics: [...DefaultColumnMetrics] as IColumnInfo[],
  columnDimensions: [] as IColumnInfo[],

  analysisPackages: [] as AnalysisPackageInfo[], // 用户号码包
  dataTableJoinRelations: [] as ITableJoinRelation[], // 探索分析为兼容旧的计算接口而定义的数据，只有一个数据
  previousHash: '', // 上次计算的条件hash
  hashEqual: false, // 条件hash是否改变
  hashEqualForSave: false, // 条件是否保存过
  hadAnalysed: false, // 是否点击过计算按钮

  condition: {
    group_by: [] as GroupBy[],
    filters: { filters: [] } as AnalysisFilters,
    metrics: [] as MetricsItem[],
    orderby: [] as OrderByItem[],
  } as Condition, // 向后台请求计算分析的值

  analysisRunning: false,
  analysisReqId: '',
  table: {}, // table 数据
  chartData: {}, // 折线图和柱状图数据
  task_id: '',
  chartType: '', // 图表类型
  statisticalMetrics: '', // 统计指标
  saveObj: {
    name: '',
    nameCn: '',
    label: '',
    business_type: 0, // 0: 个人空间 1:业务空间
    type: 1, // 0: 多维分析 1: 探索分析
  },
  regionCountries: [], // Region 组件下拉选
  popularList: [], // Region 组件下拉选
  chartContext: [],
  chartResults: [],
  sessionId: ''
});

export default {
  namespace,
  state: initState(),
  reducers: {
    save(state: any, action: { payload: any; }) {
      const newState = { ...state, ...action.payload };
      const condition = (({
        filterLogic,
        allFilters,
        allMetrics,
        allDimensions,
        optionFilters,
        optionMetrics,
        optionDimensions,
        columnFilters,
        columnMetrics,
        columnDimensions,
        filterBasic,
      }) => ({
        filterLogic,
        allFilters,
        allMetrics,
        allDimensions,
        optionFilters,
        optionMetrics,
        optionDimensions,
        columnFilters,
        columnMetrics,
        columnDimensions,
        filterBasic,
      }))(newState);

      // chosen是条件无关的属性
      condition.columnFilters.forEach((item: any) => delete item.chosen);
      condition.columnMetrics.forEach((item: any) => delete item.chosen);
      condition.columnDimensions.forEach((item: any) => delete item.chosen);

      let newHash = '';
      const conditionStr = JSON.stringify(condition);
      if (conditionStr.length > 0) {
        // newHash = crypto.createHash('sha256').update(conditionStr).digest('base64');
        newHash = crypto.enc.Base64.stringify(crypto.SHA256(conditionStr));
      }
      const { calculateHash } = action.payload;
      const { previousHash } = newState;
      let hashState: any;
      if (calculateHash === true) {
        hashState = { previousHash: newHash };
      } else {
        const hashEqual = previousHash.length === 0 || previousHash === newHash;
        hashState = { hashEqual };
        // 当计算条件发生改变后, hadAnalysed 和 hashEqualForSave 需要重置为false
        if (!hashEqual) {
          hashState.hashEqualForSave = false;
          hashState.hadAnalysed = false;
        }
      }
      return { ...newState, ...hashState };
    },
  },
  effects: {
    *initField({ payload, callback }: { payload: any; callback: Function; }, { put }: { put: any; select: any; }): any {
      const { gameCode, exploreGame } = payload;

      if (exploreGame.some((game) => game === gameCode) === false) {
        return;
      }
      const response = yield initFieldService({ game_code: gameCode });
      yield put({
        type: 'buildColumnInfos',
        payload: {
          response,
        },
      });
      yield put({
        type: 'save',
        payload: {
          gameCode,
        },
      });

      if (callback) {
        callback();
      }
    },

    *initPackageField(
      { payload, callback }: { payload: any; callback: Function; },
      { put }: { put: any; select: any; },
    ): any {
      const { gameCode } = payload;
      const params = {
        game_code: gameCode,
        page: 1,
        page_size: 1000,
      };
      const response = yield getNumberPackageList(params);
      yield put({
        type: 'buildPackageColumnInfos',
        payload: {
          response,
        },
      });

      if (callback) {
        callback();
      }
    },

    *buildColumnInfos(
      { payload }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ): any {
      const covertToColumnInfo = (tableId: string, item: any, fromMethod: string, toMethod: string) => ({
        table_id: tableId,
        column_name: item.name,
        column_type: item.type,
        column_display: item.name_zh,
        column_display_en: item.name_en || item.name_zh,
        operation: FilterOperationMap[item[fromMethod]] ?? '',
        [toMethod]: item[fromMethod],
      });

      const convertToOptionInfoInner = (menuItems: any, item: any, tableName?: string) => {
        const tabItems = menuItems.list.find((item: any) => item.tab_id === 'all');
        if (tabItems) {
          const elem = { value: item.name, name: item.name, name_zh: item.name_zh, name_en: item.name_en || item.name_zh, desc: item.desc, desc_en: item.desc_en, table_name: tableName || '' };
          tryAddNotExist(tabItems.options, elem, 'value', 'value');
        }

        if (item.recommend === true) {
          const tabFrequentItems = menuItems.list.find((item: any) => item.tab_id === 'frequent');
          if (tabFrequentItems) {
            const elem = {
              value: item.name,
              name: item.name,
              name_zh: item.name_zh,
              name_en: item.name_en || item.name_zh,
              desc: item.desc,
              desc_en: item.desc_en,
              table_name: tableName || '',
            };
            tryAddNotExist(tabFrequentItems.options, elem, 'value', 'value');
          }
        }
      };

      const convertToOptionInfo = (item: any, options: any[], tableName?: string, optionType = 0) => {
        if (optionType === 1 && item.topic === 'all') {
          // 统计指标中有几个字段是all类型的，需要在每个一级分类中出现
          options.forEach((menuItems) => {
            convertToOptionInfoInner(menuItems, item, tableName);
          });
        } else {
          const menuItems = options.find((it) => it.topic === item.topic);
          if (!menuItems) {
            return;
          }
          convertToOptionInfoInner(menuItems, item, tableName);
        }
      };

      const filterEmptyTab = (options: any[]) =>
        options.forEach((menu: any) => (menu.list = menu.list.filter((tab: any) => tab.options.length > 0)));

      const filterEmptyMenu = (options: any[]) =>
        options.filter((menu: any) => menu.list.length > 0 && menu.list.some((tab: any) => tab.options.length > 0));

      const prepareColumnInfo = (filter: any, table_id: string) =>
        filter.map((item: any) => ({
          ...item,
          table_id,
        }));

      const prepareFilterBasic = (basic: any, table_id: string) => {
        const newBasic = basic.map((item: any) => ({
          ...item,
          table_id,
        }));
        return newBasic;
      };

      const { filterBasic, columnFilters, columnMetrics } = yield select(
        (state: { [x: string]: any; }) => state[namespace],
      );

      const { response } = payload;
      const { table_id, table_name, column_info } = response;
      const allFilters: any[] = [];
      const allMetrics: any[] = [];
      const allDimensions: any[] = [];
      let optionFilters: any[] = defaultMenu();
      let optionMetrics: any[] = defaultMenu();
      let optionDimensions: any[] = defaultMenu();

      const columnSensitive: any[] = [];

      column_info.forEach((item: any) => {
        if (item.filter_mode !== 0) {
          const elem = covertToColumnInfo(table_id, item, 'filter_mode', 'filter_method');
          tryAddNotExist(allFilters, elem, 'column_name', 'column_name');
          if (filterBasic.some((it: any) => it.column_name === item.name) === false) {
            convertToOptionInfo(item, optionFilters, table_name);
          }
        }
        if (item.metric_mode !== 0) {
          const elem = covertToColumnInfo(table_id, item, 'metric_mode', 'metric_method');
          tryAddNotExist(allMetrics, elem, 'column_name', 'column_name');
          convertToOptionInfo(item, optionMetrics, table_name, 1);
        }
        if (item.groupby_mode !== 0) {
          const elem = covertToColumnInfo(table_id, item, 'groupby_mode', 'dimension_method');
          tryAddNotExist(allDimensions, elem, 'column_name', 'column_name');
          convertToOptionInfo(item, optionDimensions, table_name);
        }
        if (item.is_sensitive === true) {
          const elem = { text: item.name, name_zh: item.name_zh, value: `${table_id}.${item.name}` };
          tryAddNotExist(columnSensitive, elem, 'value', 'value');
        }
      });

      // 过滤不存在的tab
      // filterEmptyTab(optionFilters);
      filterEmptyTab(optionMetrics);
      filterEmptyTab(optionDimensions);
      // 过滤不存在的menu
      // 如果filter的主题没有任何字段，则直接过滤掉主题。但是不能现在还不能过滤tab，因为过滤之后package就没容器了
      optionFilters = filterEmptyMenu(optionFilters);

      optionMetrics = filterEmptyMenu(optionMetrics);
      optionDimensions = filterEmptyMenu(optionDimensions);
      // 生成全部Menu
      optionMetrics = generateAllMenu(optionMetrics);
      optionDimensions = generateAllMenu(optionDimensions);

      // 为columnFilter分配table_id
      const newColumnFilters = prepareColumnInfo(columnFilters, table_id);
      const newColumnMetrics = prepareColumnInfo(columnMetrics, table_id);

      // 为filterBasic固定配置分配table_id
      const newFilterBasic = prepareFilterBasic(filterBasic, table_id);

      const newPayload = {
        allFilters,
        allMetrics,
        allDimensions,
        optionFilters,
        optionMetrics,
        optionDimensions,
        columnFilters: newColumnFilters,
        columnMetrics: newColumnMetrics,
        filterBasic: newFilterBasic,
        columnSensitive,
      };

      yield put({
        type: 'save',
        payload: newPayload,
      });
    },

    *buildPackageColumnInfos(
      { payload }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ): any {
      const covertToColumnInfo = (item: any, optionsAll: any[]) => ({
        column_name: `${item.package_uuid}`,
        column_type: '',
        column_display: item.name,
        column_display_en: item.name,
        filter_method: FilterMethod.Package,
        options_all: optionsAll,
      });

      const { allFilters, columnSensitive } = yield select((state: { [x: string]: any; }) => state[namespace]);
      let { optionFilters } = yield select((state: { [x: string]: any; }) => state[namespace]);

      const convertToOptionInfo = (item: any, options: any[]) => {
        options.forEach((menu: any) => {
          const menuItems = options.find((it) => it.menu_name === menu.menu_name);
          if (!menuItems) {
            return;
          }
          const tabItems = menuItems.list.find((item: any) => item.tab_id === 'package');
          if (tabItems) {
            const elem = {
              value: `${item.package_uuid}`,
              // name: item.name,
              name_zh: item.name,
              name_en: item.name,
              desc: item.remark,
              table_name: item.analy_table_name || "",
            };
            tryAddNotExist(tabItems.options, elem, 'value', 'value');
          }
        });
      };

      const filterEmptyTab = (options: any[]) =>
        options.forEach((menu: any) => (menu.list = menu.list.filter((tab: any) => tab.options.length > 0)));

      const { response } = payload;
      const { data_list } = response;

      data_list.forEach((item: any) => {
        if (item.filter_mode !== 0) {
          const elem = covertToColumnInfo(item, columnSensitive);
          tryAddNotExist(allFilters, elem, 'column_name', 'column_name');
          convertToOptionInfo(item, optionFilters);
        }
      });

      // 过滤不存在的tab
      filterEmptyTab(optionFilters);
      // 生成全部Menu
      optionFilters = generateAllMenu(optionFilters);

      const newPayload = {
        allFilters,
        optionFilters,
      };

      yield put({
        type: 'save',
        payload: newPayload,
      });
    },

    *saveCondition(
      { payload, callback }: { payload: any; callback: Function; },
      { select, put }: { put: any; select: any; },
    ): any {
      const { business_type, label, name, nameCn, taskId, game_code } = payload;
      const create_time = moment().format('YYYY-MM-DD HH:mm:ss');
      const {
        gameCode,
        columnFilters,
        columnMetrics,
        columnDimensions,
        filterBasic,
        filterLogic,
        chartType,
        statisticalMetrics,
      }: {
        gameCode: string;
        columnFilters: IColumnInfo[];
        columnMetrics: IColumnInfo[];
        columnDimensions: IColumnInfo[];
        filterBasic: IColumnInfo[];
        filterLogic: number;
        chartType: string;
        statisticalMetrics: string;
      } = yield select((state: { [x: string]: any; }) => state[namespace]);

      const newGroupBy: GroupBy[] = [
        ...createGroupBy(columnDimensions),
        ...createGroupBy(filterBasic.filter((item) => item.column_name === dtStatDate)).map((item) => {
          // eslint-disable-next-line no-param-reassign
          item.type = DimensionType.nolyAnalysis;
          return item;
        }),
      ];
      const newFilters: FiltersItem[] = [
        ...createFiltersItem(columnFilters),
        ...createFiltersItem(filterBasic).map((item) => {
          // eslint-disable-next-line no-param-reassign
          item.connect_method = 1;
          return item;
        }),
      ];
      const newFilterBasics: FiltersItem[] = createFiltersItem(filterBasic);
      const newMetrics: MetricsItem[] = createMetricsItem(columnMetrics);
      const newCondition = {
        game_code: gameCode,
        group_by: newGroupBy,
        filters: {
          filters: newFilters,
          filters_connect_type: filterLogic,
        },
        filterBasics: newFilterBasics,
        metrics: newMetrics,
      };
      // const newAnalysisPackages = createAnalysisPackageInfo(columnFilters);
      const metrics = newMetrics?.[0];
      const metricsName = `${metrics?.table_code  }_${  metrics?.label  }${FuncNameMap[aggregateObj[metrics?.aggregate]] || ''}`;
      let param: any = {
        filter: JSON.stringify(newCondition),
        table_infos: JSON.stringify(createTableJoinRelations(filterBasic)),
        business_type,
        label,
        name,
        name_cn: nameCn,
        chart_type: chartType || 'StackBarChart', 
        statistical_metrics: statisticalMetrics || metricsName,
        create_time,
        game_code,
        type: 1,
      };
      if (!checkNullString(taskId)) {
        param = { ...param, task_id: taskId };
      }
      // if (newAnalysisPackages) {
      //   param = { ...param, package_uuid: JSON.stringify(newAnalysisPackages) };
      // }
      try {
        const resp = yield service.saveChart(param);
        yield put({
          type: 'save',
          payload: {
            hashEqualForSave: true,
          },
        });
        callback(param, resp);
      } catch (error) {
        callback(param, error);
      }
      
    },

    // 保存图表类型
    *saveChartType(
      { payload }: { payload: any; callback: Function; },
      { put }: { put: any; select: any; },
    ): any {
      const { chartType } = payload;
      yield put({
        type: 'save',
        payload: {
          chartType
        },
      });
    },

    // 保存选择指标
    *saveMetrics(
      { payload }: { payload: any; callback: Function; },
      { put }: { put: any; select: any; },
    ): any {
      const { statisticalMetrics } = payload;
      yield put({
        type: 'save',
        payload: {
          statisticalMetrics
        },
      });
    },

    *getChartDetail(
      { payload, callback }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ): any {
      try {
        const { taskId, gameCode }: { taskId: number; gameCode: string; } = payload;
        const { allFilters, allMetrics, allDimensions, filterBasic } = yield select(
          (state: { [x: string]: any; }) => state[namespace],
        );

        const taskRsp = yield service.getChartDetail({
          task_id: taskId,
          game_code: gameCode,
        });
        
        const condition = JSON.parse(taskRsp.filter);
        const tableInfos = JSON.parse(taskRsp.table_infos);
        const { filters, metrics, group_by } = condition;
        const newColumnFilters: IColumnInfo[] = [];
        const newColumnMetrics: IColumnInfo[] = [];
        const newColumnDimensions: IColumnInfo[] = [];

        filterBasic.forEach((filter: IColumnInfo) => {
          const filtersItem = filters?.filters?.find(
            (item: FiltersItem) => item.connect_method === 1 && item.column === filter.column_name,
          );
          if (filtersItem) {
            filter.column_value = filtersItem.value;
            if (filter.column_name === dtStatDate) {
              filter.column_granularity = tableInfos?.[0]?.granularity;
            }
          }
        });

        filters?.filters
          ?.filter((item: FiltersItem) => item.connect_method !== 1)
          ?.forEach((filterItem: FiltersItem) => {
            const columnInfo = allFilters.find((item: IColumnInfo) => item.column_name === filterItem.column);
            if (columnInfo) {
              newColumnFilters.push({
                ...columnInfo,
                operation: filterItem.filter_method !== FilterMethod.None ? filterItem.operation : '', // FilterMethod.None时候，将强制转成后台的数据还原
                column_value: filterItem.value,
              });
            }
          });

        metrics?.forEach((metricItem: MetricsItem) => {
          const columnInfo = allMetrics.find((item: IColumnInfo) => item.column_name === metricItem.column);
          if (columnInfo) {
            const metricFilters: IColumnInfo[] = [];
            (metricItem.filters?.filters || []).forEach((filterItem: FiltersItem) => {
              const columnInfo = allFilters.find((item: IColumnInfo) => item.column_name === filterItem.column);
              if (columnInfo) {
                metricFilters.push({
                  ...columnInfo,
                  operation: filterItem.operation,
                  column_value: filterItem.value,
                });
              }
            });
            newColumnMetrics.push({
              ...columnInfo,
              aggregate: metricItem.aggregate,
              metric_alias: metricItem.alias,
              metric_filters: metricFilters,
              metric_filter_logic: metricItem.filters?.filters_connect_type,
            });
          }
        });

        group_by
          ?.filter((item: GroupBy) => item.type !== DimensionType.nolyAnalysis)
          ?.forEach((groupByItem: GroupBy) => {
            const columnInfo = allDimensions.find((item: IColumnInfo) => item.column_name === groupByItem.column);
            if (columnInfo) {
              newColumnDimensions.push({
                ...columnInfo,
                dimension_type: groupByItem.type,
                dimension_rangs: groupByItem.range,
              });
            }
          });

        const payloadNew = {
          task_id: taskId,
          chartType: taskRsp?.chart_type,
          statisticalMetrics: taskRsp?.statistical_metrics,
          condition,
          saveObj: {
            name: taskRsp.name,
            nameCn: taskRsp.name_cn || taskRsp.name,
            label: taskRsp.label,
            business_type: taskRsp.business_type,
            type: taskRsp.type,
          },
          columnFilters: [...newColumnFilters],
          filterBasic: [...filterBasic],
          filterLogic: filters?.filters_connect_type,
          columnMetrics: [...newColumnMetrics],
          columnDimensions: [...newColumnDimensions],
        };
        // 过滤
        yield put({
          type: 'save',
          payload: payloadNew,
        });
        if (callback) {
          callback();
        }
      } catch (e) {
        console.error(e);
      }
    },

    *getDataAnlysis(
      { payload, callback }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ): any {
      try {
        const requestUniqueId = getRequestUniqueId();
        yield put({
          type: 'save',
          payload: {
            analysisRunning: true,
            analysisReqId: requestUniqueId,
          },
        });
        const {
          gameCode,
          condition: oldCondition,
          analysisPackages,
          dataTableJoinRelations,
          columnFilters,
          columnMetrics,
          columnDimensions,
          filterBasic,
          filterLogic,
        }: {
          gameCode: string;
          condition: Condition;
          analysisPackages: AnalysisPackageInfo[];
          dataTableJoinRelations: ITableJoinRelation[];
          columnFilters: IColumnInfo[];
          columnMetrics: IColumnInfo[];
          columnDimensions: IColumnInfo[];
          filterBasic: IColumnInfo[];
          filterLogic: number;
        } = yield select((state: { [x: string]: any; }) => state[namespace]);

        // isGetTableSheet是true,表示请求的是表格数据
        const { condition, isGetTableSheet, isUseOldCondition } = payload;

        let newCondition: Condition;
        let newAnalysisPackages: AnalysisPackageInfo[];
        let newDataTableJoinRelations: ITableJoinRelation[];
        if (isUseOldCondition) {
          newCondition = {
            ...oldCondition,
            ...condition,
          };
          newAnalysisPackages = analysisPackages?.map((item) => ({...item, package_uuid: String(item.package_uuid)}));
          newDataTableJoinRelations = dataTableJoinRelations;
        } else {
          // 生成新的Condition
          const newGroupBy: GroupBy[] = [
            ...createGroupBy(columnDimensions),
            ...createGroupBy(
              // 添加成后台需要的特殊处理数据
              filterBasic.filter((item) => item.column_name === dtStatDate && item.column_granularity !== 'aggregate'),
            ).map((item) => {
              // eslint-disable-next-line no-param-reassign
              item.type = DimensionType.nolyAnalysis;
              return item;
            }),
          ];
          const newFilters: FiltersItem[] = [
            ...createFiltersItem(columnFilters),
            ...createFiltersItem(filterBasic).map((item) => {
              // eslint-disable-next-line no-param-reassign
              item.connect_method = 1;
              return item;
            }),
          ];
          const newMetrics: MetricsItem[] = createMetricsItem(columnMetrics);

          newCondition = {
            game_code: gameCode,
            group_by: newGroupBy,
            filters: {
              filters: newFilters,
              filters_connect_type: filterLogic,
            },
            metrics: newMetrics,
            orderby: [],
          };

          newAnalysisPackages = createAnalysisPackageInfo(columnFilters);
          newDataTableJoinRelations = createTableJoinRelations(filterBasic);
        }

        const reqParams: Analysis = {
          queries: newCondition,
          pagesize: 2000,
          page: 1,
          is_chart: !isGetTableSheet,
          is_download: false,
          query_sequence_id: requestUniqueId,
          data_package_infos: newAnalysisPackages,
          table_infos: newDataTableJoinRelations,
        };

        const {
          table_data: tableData, // 表格数据(一位数组)
          chart_data: chartData, // 折线图和柱状图数据(二维数组)
          chart_sum_data: pieChartData, // 饼图数据(一维数组)
          metrics, // 指标(一维数组)(图表用)
          metrics_en, // 指标(一维数组)(图表用)
          column_name: columnName, // 表格头名字(一维数组)
          count, // 表格总列数
        } = yield isGetTableSheet
          ? service.getDataAnlysis(reqParams).catch((err) => {
            if (callback) {
              callback({
                errorMsg: err.data
              });
            }
          })
          : service.getDataAnlysisFull(reqParams).catch((err) => {
            if (callback) {
              callback({
                errorMsg: err.data
              });
            }
          });

        const { analysisRunning } = yield select((state: { [x: string]: any; }) => state[namespace]);
        if (analysisRunning) {
          let payloads: any = {
            table: {
              columnName,
              count,
              data: tableData,
            },
          };
          if (!isGetTableSheet) {
            payloads = {
              ...payloads,
              chartData: {
                metrics,
                metrics_en,
                lineData: chartData,
                pieChartData,
              },
            };
          }

          yield put({
            type: 'save',
            payload: {
              ...payloads,
              reqParams,
              condition: {
                ...newCondition,
              },
              analysisPackages: newAnalysisPackages,
              dataTableJoinRelations: newDataTableJoinRelations,
              calculateHash: true,
              hadAnalysed: true,
              hashEqual: true,
              hashEqualForSave: false,
            },
          });
          if (callback) {
            callback();
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    *cancelAnalysis({ payload }: { payload: any; }, { put, select }: { put: any; select: any; }): any {
      const { analysisRunning, analysisReqId } = yield select((state: { [x: string]: any; }) => state[namespace]);
      if (analysisRunning) {
        yield put({
          type: 'save',
          payload: {
            analysisRunning: false,
            analysisReqId: '',
          },
        });
        if (!checkNullString(analysisReqId)) {
          service.cancelAnalysis(analysisReqId).finally(() => {
            payload?.cancelTip("success");
          });
        }
      }
    },

    *clearQuery({ callback }: { payload: any; callback: Function; }, { put }: { put: any; select: any; }): any {
      // const {
      //   columnMetrics,
      // }: {
      //   columnMetrics: IColumnInfo[];
      // } = yield select((state: { [x: string]: any; }) => state[namespace]);

      // const newColumnMetrics = columnMetrics.filter((item) => item.column_name === DefaultColumnMetrics[0].column_name);

      yield put({
        type: 'save',
        payload: {
          columnFilters: [...ColumnFilters],
          filterLogic: 0,
          columnSensitive: [],
          columnMetrics: [],
          columnDimensions: [],
          task_id: '',
          table: {},
          chartData: {},
          hadAnalysed: false,
        },
      });

      if (callback) {
        callback();
      }
    },

    *resetState({ payload }: { payload: any; }, { put }: { put: any; }): any {
      const { gameCode } = payload;
      yield put({
        type: 'save',
        payload: { ...initState(), gameCode },
      });
    },
  
  
    // 获取地区筛选器下拉选项
    *getCountrySelector({ payload }: { payload: any; }, { put }: { put: any; select: any;}): any {
      try {
        const { gameCode, selectorList } = payload;
        const result = yield getSelector({
          game_code: gameCode,
          selector_list: selectorList
        });
        const { area_list=[], key_country_list=[]} = result;
        const newRegionCountries: any[] = [];
        area_list?.forEach((area: any) => {
          const { area_code, area_name_ch, area_name_en, country_set=[]} = area || {};
          if (area_code === "All Areas" || area_code === "GLOBAL") return;
        
          const newArea = {
            region_abbre: area_code?.toLowerCase() || "",
            region_key: area_code,
            region_name_cn: area_name_ch,
            region_name_en: area_name_en,
            country: country_set?.map((country: any) => {
              const { country_code, country_name_ch, country_name_en, deviation} = country || {};
              return {
                country_name_abbre: country_code,
                country_name_cn: country_name_ch,
                country_name_en,
                deviation,
              };
            })
          };
          newRegionCountries.push(newArea);
        });
        newRegionCountries.sort((a, b) => a?.region_name_en?.localeCompare(b?.region_name_en));
      
        const popularList = key_country_list?.map(country => country.country_code) || [];
        yield put({
          type: 'save',
          payload: {
            regionCountries: newRegionCountries,
            popularList
          }
        });
      } catch (e){
        console.error("** ", e);
      }
    },
    
    *requestChatResult(
      { payload, callback }: { payload: any; callback: Function; },
      { put, select }: { put: any; select: any; },
    ) {
      try {
        const { question, gameCode } = payload;
        const { chartContext, chartResults, sessionId} = yield select((state: { [x: string]: any; }) => state[namespace]);
        const newSessionId = sessionId || uid();
        chartContext.push({role: 'user', content: question});
        // @ts-ignore
        const {messages, reply, reply_type} = yield requestChatResult({
          session_id: newSessionId,
          messages: chartContext,
        });
       
        if (reply_type == 1) {
          const {data_count, result} = yield getTableData({
            code: "zaq1xsw2",
            game_code: gameCode,
            string: reply,
          });
          
          chartResults.push({
            tableId: "",
            // sql: sql,
            sql: checkNullString(reply)
              ? ''
              : reply.replace(/\b(SELECT|FROM|WHERE|GROUP BY)\b/gi, '\n$&'),
            data: result,
            count: data_count,
          });
        }
        
        callback(reply);
        yield put({
          type: 'save',
          payload: {
            chartContext: messages || [...chartContext, {role: 'assistant', content: 'reply'}],
            chartResults: [...chartResults],
            sessionId: newSessionId
          }
        });
        
      } catch (e) {
        callback(null, e);
        console.log("chat error", e);
      }
    }
  },
};

const createAnalysisPackageInfo = (columnFilters: IColumnInfo[]) => {
  const newAnalysisPackages: AnalysisPackageInfo[] = (
    columnFilters.filter((item) => item.filter_method === FilterMethod.Package) || []
  ).map((item) => {
    const analysisPackageInfo: AnalysisPackageInfo = {
      package_uuid: String(item.column_name),
      relate_column: [
        {
          table_id: item.column_value?.[0]?.split('.')?.[0],
          column: item.column_value?.[0]?.split('.')?.[1],
          table_code: "t0"
        }
      ],
    };
    return analysisPackageInfo;
  });
  return newAnalysisPackages;
};

const createTableJoinRelations = (columnFilters: IColumnInfo[]) => [
  {
    table_id: columnFilters.find((item) => item.column_name === dtStatDate)?.table_id ?? '',
    granularity: columnFilters.find((item) => item.column_name === dtStatDate)?.column_granularity ?? '',
    table_code: 't0',
  },
];
